import * as React from 'react';
import { useEffect, useRef } from 'react';

import Row from 'antd/lib/row';
import Col from 'antd/lib/col';

const ctBaseUrl = 'https://app.cleartriage.com';
const ctLoginToken = 'Hiy3PkhJ2ojQoXoIlGNRBvTTEseS';
const firstName = 'Rohit';

const ClearTriage = (props: any) => {
  const iframe = useRef(null);
  const callSummary = useRef(null);

  // Initialize a session with ClearTriage
  const initSession = () => {
    iframe.current.contentWindow.postMessage({
        subject: 'ct-init',
      }, ctBaseUrl);
  }
  // Handle an initialization error from ClearTriage. This can happen if your origin URL is not whitelisted on your account.
  const handleInitError = (eventData: any) => {
    console.log('ct-init error: ' + eventData.messageBody);
  }
  // Handle successful return of a call summary from ClearTriage
  const handleCtCallSummary = (event: any) => {
    if (event.origin === ctBaseUrl) {
      // callSummary.current.innerHTML = JSON.stringify(event.data);
    }
    else {
      console.log('ct-call-summary broadcast from unexpected origin: ' + event.origin);
    }
  }
  const handleMessage = (event: any) => {
    if (event.data && event.data.subject) {
      switch (event.data.subject) {
        case 'ct-ready':
          initSession();
          handleIframeLoad();
          break;
        case 'ct-init-err':
          handleInitError(event.data);
          break;
        case 'ct-call-summary':
          handleCtCallSummary(event);
      }
    }
  }

  const handleIframeLoad = () => {
    const iframeDocument = iframe.current.contentDocument || iframe.current.contentWindow?.document;
    if (iframeDocument) {
      const body = iframeDocument.getElementsByTagName('body')[0];

      if (body) {
        console.log('iframebody', body);
        body.style.background = '#f0f2f5 !important';
      }
    }
  }

  useEffect(() => {
    iframe.current = document.createElement('iframe');
    iframe.current.src = ctBaseUrl + '/app/login/sso/' + ctLoginToken + '?firstName=' + firstName;
    iframe.current.id = 'ct-iframe'
    iframe.current.width = "100%";
    iframe.current.height = 600;
    iframe.current.referrerpolicy = 'same-origin'

    const iframeContainer = document.querySelector('#container')
    iframeContainer.appendChild(iframe.current);

    callSummary.current = document.createElement('code');
    document.body.appendChild(callSummary.current);
    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    }
  }, []);

  return (
    <div id="container" style={{display: 'block', visibility: 'visible'}}></div>
  );
};

export default ClearTriage;
